import { canv } from "@/canv/global";
import { setClick } from "@/canv/utils";
import { t } from "@/i18n";

export class CursorTrackingWindow {
    open(sessionUID: string) {
        const cursorFollowInviteUser = canv.multiManager.findMultiUser(sessionUID);

        if (!cursorFollowInviteUser) return;

        this.close();

        this.name = cursorFollowInviteUser.name;
        this.sessionUID = sessionUID;

        const cursorTrackingWindowWrapper = document.createElement("div");
        cursorTrackingWindowWrapper.classList.add("cursorTrackingWindowWrapper");
        document.body.prepend(cursorTrackingWindowWrapper);

        cursorTrackingWindowWrapper.innerHTML += this.getTemplate();

        this.init();
    }

    close() {
        const cursorTrackingWindowWrapper = document.getElementsByClassName(
            "cursorTrackingWindowWrapper",
        )[0] as Element | undefined;
        if (cursorTrackingWindowWrapper !== undefined) {
            cursorTrackingWindowWrapper.outerHTML = "";
        }

        this.name = "";
        this.sessionUID = null;
    }

    init() {
        setClick("cancelTrackingBtn", this.cancelTrackingClick.bind(this));
        setClick("acceptTrackingBtn", this.acceptTrackingClick.bind(this));
    }

    cancelTrackingClick() {
        this.close();
    }

    acceptTrackingClick() {
        if (this.sessionUID && canv.multiManager.findMultiUser(this.sessionUID)) {
            canv.multiManager.tryViewSubscribe(this.sessionUID);
        }
        this.close();
    }

    getTemplate() {
        return `
            <div class="cursorTrackingWindow">
                <div class="cursorTrackingWindowInfo">${t("cursorTracking.invite", { name: this.name })}</div>
                <div class="cursorTrackingBtns">
                  <div class="acceptTrackingBtn">${t("cursorTracking.accept")}</div>
                  <div class="cancelTrackingBtn">${t("cursorTracking.decline")}</div>
                </div>

            </div>
        `;
    }

    sessionUID: string | null = null;
    name = "";
}
